import { render, staticRenderFns } from "./SalesmanItem.vue?vue&type=template&id=0c7e1f3f"
import script from "./SalesmanItem.vue?vue&type=script&lang=js"
export * from "./SalesmanItem.vue?vue&type=script&lang=js"
import style0 from "./SalesmanItem.vue?vue&type=style&index=0&id=0c7e1f3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports